import React, { useState, useEffect, useCallback } from 'react';
import './Introduction.css';

const Introduction = ({ expiryDate }) => {
  const calculateTimeLeft = useCallback(() => {
    const difference = new Date(expiryDate) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        weeks: Math.floor(difference / (1000 * 60 * 60 * 24 * 7)),
        days: Math.floor((difference / (1000 * 60 * 60 * 24)) % 7),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
      };
    }

    return timeLeft;
  }, [expiryDate]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Cleanup the interval on component unmount
  }, [calculateTimeLeft]);

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (timeLeft[interval] > 0) {  // Only add if the value is greater than 0
      timerComponents.push(
        <span key={interval} className="time-section">
          {timeLeft[interval]} <span className="interval-label">{interval}</span>
        </span>
      );
    }
  });

  return (
    <section className="introduction">
      <h2>Welcome to the Church Information Update Form</h2>
      <p>Please review and update your church's information below.</p>
      <p className="countdown">
        Link Expires in: {timerComponents.length ? timerComponents : <span>Time's up!</span>}
      </p>
    </section>
  );
};

export default Introduction;
